import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigComponent } from './config.component';
import { ConfigRoutesModule } from './config-routes/config-routes.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CardModule} from '../../resources/components/card/card.module';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../resources/modules/form-group-context/form-group-simple/form-group-simple.module';
import {ValidateModule} from '../../resources/modules/validate/validate.module';
import {FormGroupSelectModule} from '../../resources/modules/form-group-context/form-group-select/form-group-select.module';



@NgModule({
  declarations: [
    ConfigComponent
  ],
  imports: [
    CommonModule,
    ConfigRoutesModule,
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    FormGroupSelectModule,
  ]
})
export class ConfigModule { }
